import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Observable} from 'rxjs';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {Error} from "app/components/sign/form/static/error";

export class Input extends Component {
    static get propTypes() {
        return {
            label: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired,
            errors$: PropTypes.instanceOf(Observable).isRequired,
            handleChange$: PropTypes.instanceOf(Observable).isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {value: null, errors: []};
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.errors$.subscribe((errors) => {
            this.setState({errors})
        });
    }

    handleChange(evt) {
        this.setState({value: evt.target.value});
        this.props.handleChange$.next(evt.target.value);
    }

    render() {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        required
                        autoComplete="nope"
                        error={this.state.errors.length > 0}
                        type={this.props.type}
                        label={this.props.label}
                        onChange={this.handleChange}
                        variant="outlined"
                        margin="normal"/>
                </Grid>
                {this.state.errors.length > 0 && <Grid item xs={12}>
                    <Error errors={this.state.errors}/>
                </Grid>}
            </Grid>
        );
    }
}
